// import React from 'react';

// const ProductCard = ({ image, title, subtitle, overlayColor, overlayContent, link }) => {
//   const handleClick = () => {
//     if (link) {
//       window.open(link, '_blank', 'noopener,noreferrer');
//     }
//   };

//   return (
//     <div 
//       className="relative group w-80 h-80 rounded-lg overflow-hidden cursor-pointer"
//       onClick={handleClick}
//     >
//       {/* Main Image */}
//       <div className="w-full h-full bg-cover bg-center transition-all duration-300 group-hover:scale-105">
//         <img 
//           src={image} 
//           alt={title}
//           className="w-full h-full object-cover"
//         />
//       </div>
      
//       {/* Hover Overlay */}\
//       <div 
//         className={`absolute inset-0 ${overlayColor} opacity-0 group-hover:opacity-95 transition-all duration-300 flex flex-col justify-center items-start p-8`}
//       >

// <div className="flex justify-between items-start mb-12">
//             <div className="w-16 h-16 bg-gradient-to-br from-white/30 to-white/10 rounded-xl backdrop-blur-sm border border-white/20 flex items-center justify-center">
//               <div className="w-8 h-8 bg-white/40 rounded-lg"></div>
//             </div>
//             <div className="w-3 h-3 bg-white/60 rounded-full animate-pulse"></div>
//           </div>

//         <div className="text-white transform translate-y-4 group-hover:translate-y-0 transition-all duration-500 delay-100">
//           <h2 className="text-4xl font-light mb-3 transform translate-x-4 group-hover:translate-x-0 transition-all duration-500 delay-150">
//             {title}
//           </h2>
//           <div className="flex items-center space-x-3 mb-6 transform translate-x-4 group-hover:translate-x-0 transition-all duration-500 delay-200">
//             <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
//             <span className="text-2xl font-light">{subtitle}</span>
//           </div>
          
          
//           {/* Interactive Elements */}
//            {/* Link indicator */}
//            {link && (
//             <div className="mt-8 flex items-center space-x-2 text-sm opacity-90 transform translate-y-4 group-hover:translate-y-0 group-hover:translate-x-2 transition-all duration-500 delay-300">
//               <span className="font-medium">Click to view</span>
//               <svg className="w-4 h-4 transform group-hover:rotate-45 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
//               </svg>
//             </div>
//           )}
//           </div>
//          {/* Floating Elements */}
//          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10">
//             <div className="w-32 h-32 bg-white rounded-full animate-pulse"></div>
//           </div>
//           <div className="absolute top-1/3 right-8 w-4 h-4 bg-white/30 rounded-full animate-bounce delay-300"></div>
//           <div className="absolute bottom-1/3 left-8 w-6 h-6 bg-white/20 rounded-full animate-bounce delay-700"></div>
//         </div>

//         {/* Border Glow Effect */}
//         <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-white/30 transition-all duration-300"></div>
        
//         {/* Bottom Shine Effect */}
//         <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/50 to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
//       </div>
    
//   );
// };

// const ProductShowcase = () => {
//   const products = [
//      {
//       id: 1,
//       image: "/assets/travel.jpg",
//       title: "Travel",
//  subtitle:"Blinds",
//       link: "/travel",
//       overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600",
//       overlayContent: (
//         <div className="text-white space-y-3 text-sm">
//         <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//           <div className="w-8 h-8 bg-white/40 rounded"></div>
//         </div>
//       </div>
      
   

 
//       )
//     },

//     {
//       id: 2,
//       image:"/assets/sc.jpg",
//       title:"H&M ",
//        subtitle:"Scratch to win ",
//       link:"/ad1",
//       overlayColor:"bg-gradient-to-br from-amber-600 to-blue-600",
//       overlayContent: (
//         <div className="text-white space-y-3 text-sm">
//         <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//           <div className="w-8 h-8 bg-white/40 rounded"></div>
//         </div>
//       </div>
      
//       )
//     },
//     {
//       id: 3,
//       image:"/assets/sw.webp",
//             title:"Pizza Hut",
//              subtitle:"Swipe To Reveal ",
//             link:"/ad2",
//             overlayColor:"bg-gradient-to-br from-amber-600 to-blue-600",
//       overlayContent: (
//          <div className="text-white space-y-3 text-sm">
//         <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//           <div className="w-8 h-8 bg-white/40 rounded"></div>
//         </div>
//       </div>
      
//       )
//     },
//     // {
//     //   id: 3,
//     //   image: "/assets/lable.png",
//     //   title: "Black Lable",
//     //   subtitle: "Animation",
//     //   link: "/lable",
//     //   overlayColor: "bg-gradient-to-br from-teal-400 to-teal-500",
//     //   overlayContent: (
//     //     <div className="grid grid-cols-2 gap-4">
//     //       <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//     //         <div className="w-8 h-8 bg-white rounded"></div>
//     //       </div>
//     //       <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//     //       <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//     //       <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//     //     </div>
//     //   )
//     // },
//     {
//       id: 4,
//       image:"/assets/tap.cms",
//       title:"Thums Up",
//       subtitle:"Tap to Reveal",
//       link:"/ad3",
//       overlayColor:"bg-gradient-to-br from-amber-600 to-blue-600",
//       overlayContent: (
//         <div className="text-white space-y-3 text-sm">
//         <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//           <div className="w-8 h-8 bg-white/40 rounded"></div>
//         </div>
//       </div>
      
//       )
//     }
//     // {
//     //   id: 4,
//     //   image: "/assets/miles.png",
//     //   title: "turkish Airlines",
//     //   subtitle: "Animation",
//     //   link: "/miles",
//     //   overlayColor: "bg-gradient-to-br from-green-600 to-emerald-600",
//     //   overlayContent: (
//     //     <div className="grid grid-cols-2 gap-4">
//     //       <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//     //         <div className="w-8 h-8 bg-white rounded"></div>
//     //       </div>
//     //       <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//     //       <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//     //       <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//     //     </div>
//     //   )
//     // }
//   ];

//   return (
//     <div className="min-h-screen p-8">
//       <div className="max-w-7xl mx-auto">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {products.map((product) => (
//             <ProductCard
//               key={product.id}
//               image={product.image}
//               title={product.title}
//               subtitle={product.subtitle}
//               overlayColor={product.overlayColor}
//               overlayContent={product.overlayContent}
//               link={product.link}
//             />
//           ))}
//         </div>

//         {/* Additional Row */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-8">
//           {/* <ProductCard
//             image="/assets/lable.png"
//             title="Black Lable"
//             subtitle="Animation"
//             link="/lable"
//             overlayColor="bg-gradient-to-br from-orange-500 to-yellow-500"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white rounded"></div>
//               </div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//             </div>
//             }
//           /> */}
   
//    <ProductCard
//             image="/assets/du.jpg"
//             title=" Dubai Travel"
//             subtitle="Interactive Selector "
//             link="/travel-ramadan"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//         <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//           <div className="w-8 h-8 bg-white/40 rounded"></div>
//         </div>
//       </div>
      
//             }
//           />
//      <ProductCard
//             image="/assets/rama.webp"
//             title=" Ramadan"
//              subtitle="Quiz"
//             link="/ramadan"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//         <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//           <div className="w-8 h-8 bg-white/40 rounded"></div>
//         </div>
//       </div>
      
//             }
//           />
//             <ProductCard
//             image="/assets/zakat.webp"
//             title="Zakat Calculator"
//              subtitle="Dynamic Calculator "
//             link="/zakat"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//            <ProductCard
//             image="/assets/donation.png"
//             title="Donation"
//              subtitle="Interactive Selector "
//             link="/donation"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//              <ProductCard
//             image="/assets/mam1.jpg"
//             title="MamaEarth"
//              subtitle="Spin the wheel "
//             link="/mamaearth"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//      <ProductCard
//             image="/assets/prism.jpg"
//             title="Prism"
//              subtitle="3D Prism"
//             link="/prism"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//              <ProductCard
//             image="/assets/canesten.webp"
//             title="Canesten"
//              subtitle="Gamification "
//             link="/canesten"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//             <ProductCard
//             image="/assets/car4.webp"
//             title="Car 360"
//              subtitle="360 Rotate "
//             link="/carrotate"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//            <ProductCard
//             image="/assets/luxary.webp"
//             title="Luxury Closet "
//             subtitle="Hotspot "
//             link="/luxarycloset"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
// <ProductCard
//             image="/assets/pepsi.webp"
//             title="Pepsi"
//             subtitle="Native Display"
//             link="/pepsi"
//             overlayColor="bg-gradient-to-br from-amber-600 to-orange-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />

// <ProductCard
//             image="/assets/sama.avif"
//             title="Samsung"
//             subtitle="Gamification"
//             link="/samsung"
//             overlayColor="bg-gradient-to-br from-amber-600 to-orange-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//             <ProductCard
//             image="/assets/moll.avif"
//             title="Mollers"
//             subtitle="Video"
//             link="/mollers"
//             overlayColor="bg-gradient-to-br from-amber-600 to-orange-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//            <ProductCard
//             image="/assets/tiger.avif"
//             title="Tiger"
//             subtitle="Video"
//             link="/tiger"
//             overlayColor="bg-gradient-to-br from-amber-600 to-orange-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//              {/* <ProductCard
//             image="/assets/bir.avif"
//             title="Birra Moretti"
//             subtitle="Animation 3d "
//             link="/birra"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           /> */}
//       <ProductCard
//             image="/assets/ab.avif"
//             title="ABC Beer"
//             subtitle="Drag To Reveal "
//             link="/abcbeer"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//     <ProductCard
//             image="/assets/ps.avif"
//             title="PS 5"
//              subtitle="Tap to Reveal "
//             link="/ps"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//             <ProductCard
//             image="/assets/dlf.webp"
//             title="DLF"
//              subtitle="CTV QR Code L Band"
//             link="/dlf"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
//           <ProductCard
//             image="/assets/len.png"
//             title="Lenovo"
//              subtitle="CTV Carousel L Band"
//             link="/lenovo"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="text-white space-y-3 text-sm">
//               <div className="w-16 h-16 bg-white/20 rounded-lg backdrop-blur-sm border border-white/30 transform hover:scale-110 transition-transform duration-300 flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white/40 rounded"></div>
//               </div>
//             </div>
            
//             }
//           />
            
          

// {/* <ProductCard
//             image="/assets/oreo.png"
//             title="Oreo"
//             subtitle="Animation "
//             link="/oreo"
//             overlayColor="bg-gradient-to-br from-blue-600 to-indigo-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white rounded"></div>
//               </div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//             </div>
//             }
//           />


// <ProductCard
//             image="/assets/tusker.png"
//             title="Tusker"
//             subtitle="Forced Prespective "
//             link="/tusker"
//             overlayColor="bg-gradient-to-br from-blue-600 to-indigo-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white rounded"></div>
//               </div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//             </div>
//             }
//           />
//            <ProductCard
//             image="/assets/lable.png"
//             title="Black Lable"
//             subtitle="nimation"
//             link="/lable"
//             overlayColor="bg-gradient-to-br from-blue-600 to-indigo-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white rounded"></div>
//               </div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//             </div>
//             }
//           />
//            <ProductCard
//             image="/assets/miles.png"
//             title="Miles"
//             subtitle="Animation "
//             link="/miles"
//             overlayColor="bg-gradient-to-br from-blue-600 to-indigo-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white rounded"></div>
//               </div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//             </div>
//             }
//           />
//           <ProductCard
//             image="/assets/coc.png"
//             title="Coca Cola"
//             subtitle="Animation "
//             link="/coke"
//             overlayColor="bg-gradient-to-br from-blue-600 to-indigo-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//                 <div className="w-8 h-8 bg-white rounded"></div>
//               </div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//               <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//             </div>
//             }
//           />
          
//           <ProductCard
//             image="/assets/oral.png"
//             title="Oral B"
//             subtitle="Forced Perspective"
//             link="/oral"
//             overlayColor="bg-gradient-to-br from-gray-700 to-gray-800"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
      
//           <ProductCard
//             image="/assets/men.avif"
//             title="Mentos"
//             subtitle="Animation 3d "
//             link="/mint"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
    
//                <ProductCard
//             image="/assets/mars.avif"
//             title="Mars"
//             subtitle="Forced Prespective "
//             link="/mars"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
//             <ProductCard
//             image="/assets/vivo.avif"
//             title="Vivo"
//             subtitle="Forced Prespective "
//             link="/vivo"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
//            <ProductCard
//             image="/assets/elmen.avif"
//             title="Elmenhorster"
//             subtitle="Forced Prespective "
//             link="/elmenhorster"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
//             <ProductCard
//             image="/assets/zen.avif"
//             title="Zen Diamond"
//             // subtitle="Forced Prespective "
//             link="/zen"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
//           <ProductCard
//             image="/assets/lipton.avif"
//             title="Lipton"
//             // subtitle="Forced Prespective "
//             link="/lipton"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
//           <ProductCard
//             image="/assets/lays.avif"
//             title="Lays"
//             // subtitle="Forced Prespective "
//             link="/lays"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
//           <ProductCard
//             image="/assets/fold.avif"
//             title="Samsung Fold"
//             // subtitle="Forced Prespective "
//             link="/fold"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
//            <ProductCard
//             image="/assets/newsam.avif"
//             title="Samsung Fold"
//             // subtitle="Forced Prespective "
//             link="/foldnew"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           />
//           <ProductCard
//             image="/assets/fanta.avif"
//             title="Fanta"
//             // subtitle="Forced Prespective "
//             link="/fanta"
//             overlayColor="bg-gradient-to-br from-amber-600 to-blue-600"
//             overlayContent={
//               <div className="grid grid-cols-2 gap-4">
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
//             <div className="w-8 h-8 bg-white rounded"></div>
//           </div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-20 rounded-lg"></div>
//           <div className="w-16 h-16 bg-white bg-opacity-30 rounded-lg"></div>
//         </div>
//             }
//           /> */}
       
   
          
        
       
            
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductShowcase;

import React from 'react';

const ProductCard = ({ image, title, subtitle, overlayColor, overlayContent, link }) => {
  const handleClick = () => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div 
      className="relative group w-full aspect-square rounded-lg overflow-hidden cursor-pointer max-w-sm mx-auto"
      onClick={handleClick}
    >
      {/* Main Image */}
      <div className="w-full h-full bg-cover bg-center transition-all duration-300 group-hover:scale-105">
        <img 
          src={image} 
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Hover Overlay */}
      <div 
        className={`absolute inset-0 ${overlayColor} opacity-0 group-hover:opacity-95 transition-all duration-300 flex flex-col justify-center items-start p-6 sm:p-8`}
      >
        <div className="flex justify-between items-start mb-6 sm:mb-12 w-full">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-white/30 to-white/10 rounded-xl backdrop-blur-sm border border-white/20 flex items-center justify-center">
            <div className="w-6 h-6 sm:w-8 sm:h-8 bg-white/40 rounded-lg"></div>
          </div>
          <div className="w-3 h-3 bg-white/60 rounded-full animate-pulse"></div>
        </div>

        <div className="text-white transform translate-y-4 group-hover:translate-y-0 transition-all duration-500 delay-100">
          <h2 className="text-2xl sm:text-3xl lg:text-3xl font-light mb-3 transform translate-x-4 group-hover:translate-x-0 transition-all duration-500 delay-150">
            {title}
          </h2>
          <div className="flex items-center space-x-3 mb-6 transform translate-x-4 group-hover:translate-x-0 transition-all duration-500 delay-200">
            <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
            <span className="text-lg sm:text-xl lg:text-2xl font-light">{subtitle}</span>
          </div>
          
          {/* Link indicator */}
          {link && (
            <div className="mt-4 sm:mt-8 flex items-center space-x-2 text-xs sm:text-sm opacity-90 transform translate-y-4 group-hover:translate-y-0 group-hover:translate-x-2 transition-all duration-500 delay-300">
              <span className="font-medium">Click to view</span>
              <svg className="w-4 h-4 transform group-hover:rotate-45 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </div>
          )}
        </div>

        {/* Floating Elements */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10">
          <div className="w-24 h-24 sm:w-32 sm:h-32 bg-white rounded-full animate-pulse"></div>
        </div>
        <div className="absolute top-1/3 right-6 sm:right-8 w-3 h-3 sm:w-4 sm:h-4 bg-white/30 rounded-full animate-bounce delay-300"></div>
        <div className="absolute bottom-1/3 left-6 sm:left-8 w-4 h-4 sm:w-6 sm:h-6 bg-white/20 rounded-full animate-bounce delay-700"></div>

        {/* Border Glow Effect */}
        <div className="absolute inset-0 rounded-lg border-2 border-transparent group-hover:border-white/30 transition-all duration-300"></div>
        
        {/* Bottom Shine Effect */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/50 to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
      </div>
    </div>
  );
};

const ProductShowcase = () => {
  const products = [
    {
      id: 1,
      image: "/assets/travel.webp",
      title: "Travel",
 subtitle:"Blinds",
      link: "/blinds/travel",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 3,
      image:"/assets/recard.png",
      title:"Pernod Ricard",
       subtitle:"CTV Quiz ",
      link:"/ctv-quiz/recard",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 4,

      image:"/assets/StaccatoDetail.png",
      title:" Staccato",
      subtitle:"Push Notification",
      link:"/push-notification/staccato",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 5,
      image:"/assets/sw.jpg",
            title:"Pizza Hut",
             subtitle:"Swipe To Reveal ",
            link:"/swipe-to-reveal/pizza",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 6,


      image: "/assets/herohome.png",
      title: " Hero Homes",
 subtitle:"CTV L Band",
      link: "/ctv-l-band/realty",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
     
    },
    {
      id: 7,
      image:"/assets/du.jpg",
            title:" Dubai Travel",
            subtitle:"Interactive Selector ",
            link:"/interactive-selector/travel-ramadan",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 8,
      image: "/assets/rama.webp",
      title: "Ramdan",
 subtitle:"Quiz",
      link: "/quiz/ramadan",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 9,

      image:"/assets/sc.avif",
      title:"H&M ",
       subtitle:"Scratch to win ",
      link:"/scratch-to-win/hm",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 10,
      image: "/assets/donation.png",
      title: "Donation",
 subtitle:"Interactive Selector ",
      link: "/interactive-selector/donation",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },    {
      id: 11,
      image: "/assets/mam1.jpg",
      title: "MamaEarth",
 subtitle:"Spin the wheel",
      link: "/spin-the-wheel/mamaearth",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 12,
      image: "/assets/prism11.jpg",
      title: "Prism",
 subtitle:"3D Prism",
      link: "/3d-prism/prism",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 13,
      image: "/assets/plb.png",
      title: "PLB",
 subtitle:"CTV J Band",
      link: "/ctv-j-band/plb",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
   
    },
    {
      id: 14,

      image: "/assets/Lenovo.avif",
      title: "Lenovo",
 subtitle:"CTV Carousel L Band",
      link: "/ctv-carousel-l-band/lenovo",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"

    },
    {
      id: 15,
      image: "/assets/luxary.webp",
      title: "Luxury Closet",
 subtitle:"Hotspot",
      link: "/hotspot/luxarycloset",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 16,
      image: "/assets/pepsi.webp",
      title: "Pepsi",
 subtitle:"Native Display",
      link: "/native-display/pepsi",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 17,
      image: "/assets/sama.jpg",
      title: "Samsung",
 subtitle:"Gamification",
      link: "/gamification/samsung",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 18,

      image:"/assets/fitflop.png",
      title:" Fitflop",
      subtitle:"Push Notification",
      link:"/push-notification/fitflop",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
     
    },
    {
      id: 19,
      image: "/assets/tiger.avif",
      title: "Tiger",
 subtitle:"Video",
      link: "/video/tiger",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 20,
      image: "/assets/ab.avif",
      title: "ABC Beer",
 subtitle:"Drag To Reveal ",
      link: "/drag-to-reveal/abcbeer",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 21,
      image: "/assets/ps.avif",
      title: "PS 5",
 subtitle:"Tap to Reveal",
      link: "/tap-to-reveal/ps",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 22,
      image: "/assets/dlf.webp",
      title: "DLF",
 subtitle:"CTV QR Code L Band",
      link: "/ctv-qr-code-l-band/dlf",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 23,
      image: "/assets/car121.webp",
      title: "Car 360",
 subtitle:"360 Rotate",
      link: "/360rotate/carrotate",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 24,


      image: "/assets/canesten.webp",
      title: "Canesten",
 subtitle:"Gamification",
      link: "/gamification/canesten",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 24,
      image:"/assets/tmmm.png",
      title:"Thums Up",
      subtitle:"Tap to Reveal",
      link:"/tap-to-reveal/thumsup",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 24,
      image: "/assets/moll.avif",
      title: "Mollers",
 subtitle:"Video",
      link: "/video/mollers",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
    {
      id: 25,
      image:"/assets/zakat.webp",
      title:"Zakat Calculator",
       subtitle:"Dynamic Calculator ",
      link:"/dynamic-calculator/zakat",
      overlayColor: "bg-gradient-to-br from-amber-600 to-blue-600"
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        {/* <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light text-gray-800 mb-4">
            Interactive Showcase
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover our collection of interactive digital experiences
          </p>
        </div> */}

        {/* Product Grid - Mobile: 1 column, Tablet: 2 columns, Desktop: 3-4 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              image={product.image}
              title={product.title}
              subtitle={product.subtitle}
              overlayColor={product.overlayColor}
              link={product.link}
            />
          ))}
        </div>

        {/* Footer */}
        {/* <div className="text-center mt-12 sm:mt-16">
          <p className="text-gray-500 text-sm">
            Hover over cards to see interactive previews
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default ProductShowcase;